import { Link, Typography } from "@mui/material";
import { Theme, useTheme } from "@mui/material/styles";
import CookieConsent from "react-cookie-consent";
import ReactGA from "react-ga4";
import { useTranslation } from "react-i18next";
import { GOOGLE_MEASUREMENT_ID } from "src/lib/config.helper";

import { useConsent } from "./ConsentProvider";

const COOKIES_TO_DELETE = ["_ga", `_ga_${GOOGLE_MEASUREMENT_ID}`, `_ga_${GOOGLE_MEASUREMENT_ID.slice(2)}`, "_gid", "_gat"];
const DOMAINS_TO_DELETE_COOKIES = [window.location.hostname, "." + window.location.hostname.split(".").slice(-2).join(".")];

const getStyles = (theme: Theme) => ({
  bannerStyle: {
    zIndex: 9999,
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    borderTop: `solid 1px ${theme.palette.border.default}`,
    fontFamily: theme.typography.fontFamily,
  },
  rejectButtonStyle: {
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.primary.main,
    borderRadius: theme.radius.sm,
    border: "solid 1px",
    fontSize: theme.fontSizes.lg,
    fontFamily: theme.typography.fontFamily,
  },
  acceptButtonStyle: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.background.paper,
    borderRadius: theme.radius.sm,
    fontSize: theme.fontSizes.lg,
    fontFamily: theme.typography.fontFamily,
  },
});

function revokeConsent() {
  window?.gtag &&
    window?.gtag("consent", "update", {
      analytics_storage: "denied",
    });
  deleteGACookies();
}

// Remove GA cookies (domain: your site, path: /)
function deleteGACookies() {
  for (const domain of DOMAINS_TO_DELETE_COOKIES) {
    for (const cookieName of COOKIES_TO_DELETE) {
      document.cookie = `${cookieName}=; Max-Age=0; path=/; domain=${domain};`;
    }
  }
}

function CookieBanner() {
  const { consent, setConsent, forceBanner, setForceBanner } = useConsent();
  const { t } = useTranslation();
  const theme = useTheme();
  const styles = getStyles(theme);

  if (typeof consent === "undefined" || forceBanner) {
    return (
      <CookieConsent
        location='bottom'
        buttonText={t("Accept")}
        declineButtonText={t("Reject")}
        debug
        enableDeclineButton
        cookieName='userConsent'
        style={styles.bannerStyle}
        buttonStyle={styles.acceptButtonStyle}
        declineButtonStyle={styles.rejectButtonStyle}
        expires={365}
        onAccept={() => {
          ReactGA.initialize(GOOGLE_MEASUREMENT_ID);
          setConsent("true");
          setForceBanner(false);
        }}
        onDecline={() => {
          revokeConsent();
          setConsent("false");
          setForceBanner(false);
        }}
      >
        <Typography variant='body2' lineHeight={1.5}>
          {t("We use cookies to understand how our app is used and to improve its features and user experience")}
          <br />
          <Link href='https://ase.ch/en/disclaimer/' target='_blank' rel='noopener' underline='none'>
            {t("Privacy Policy")}
          </Link>
        </Typography>
      </CookieConsent>
    );
  }
  return null;
}

export default CookieBanner;
